import {
	RESET_UPLOAD_RECEIPT_STATE,
	RESET_PROCESS_ERROR,
	SET_UPLOAD_RECEIPT_LIST,
	UPLOAD_DECODE_TARGET,
	SUCCESS_UPLOAD_DECODE_TARGET,
	FAIL_UPLOAD_DECODE_TARGET,
	UPLOAD_MANUAL_DECODE,
	SUCCESS_UPLOAD_MANUAL_DECODE,
	FAIL_UPLOAD_MANUAL_DECODE,
	OPEN_RECEIPT_MANUAL_INPUT,
} from '../actions';

const initialState = {
	isFetching: false,
	isUploading : false,
	isProcessError : false,
	uploadList:[],
	lastFileManageNO:0,
	success_data:[],
	error_data:[],
	complete_data:[],
	isSuccessUpload:false,
	isCompleteUpload:false
};
export default function uploadReceiptSettings(state = initialState, action) {
	let ret = Object.assign({}, state,{});
	switch (action.type) {
		case SET_UPLOAD_RECEIPT_LIST:
			return Object.assign({}, state, action.payload);
		case UPLOAD_DECODE_TARGET:
			ret.isUploading = true;
			return ret;
		case SUCCESS_UPLOAD_DECODE_TARGET:
			ret.success_data = action.payload.success_data;
			ret.error_data = action.payload.error_data;
			ret.complete_data = action.payload.complete_data;
			ret.isCompleteUpload = action.payload.complete_data.length > 0;
			ret.isSuccessUpload = true;
			ret.isUploading = false;
			return ret;
		case FAIL_UPLOAD_DECODE_TARGET:
			ret.isUploading = false;
			ret.isProcessError = true;
			return ret;
		case OPEN_RECEIPT_MANUAL_INPUT:
			ret.isSuccessUpload = false;
			return ret;
		case UPLOAD_MANUAL_DECODE:
			ret.isFetching = true;
			return ret;
		case SUCCESS_UPLOAD_MANUAL_DECODE:
			ret.complete_data = action.payload.complete_data;
			ret.isCompleteUpload = action.payload.complete_data.length > 0;
			ret.error_data = [];
			ret.isSuccessUpload = true;
			ret.isFetching = false;
			return ret;
		case FAIL_UPLOAD_MANUAL_DECODE:
			ret.isFetching = false;
			ret.isProcessError = true;
			return ret;
		case RESET_UPLOAD_RECEIPT_STATE:
			Object.keys(initialState).forEach(key=>{
				ret[key] = initialState[key];
			});
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/upload-receipt.js